import { useQuery } from "@tanstack/react-query";

import { allModelsQuery } from "#modules/models/infra/allModels.query";

export const useAllModels = () => {
  const { data, ...rest } = useQuery({ ...allModelsQuery() });

  return { allModels: data ?? [], ...rest };
};
